<app-spinner class="email-confirmation__spinner"></app-spinner>
